import "../styles/WhyUs.css";

export default function WhyUsSection() {
  return (
    <div id="WhyUsSection">
      <h2>Miért válassza az SOS Elevator Kft.-t?</h2>
      <p>
        Az SOS Elevator Kft. a liftek és mozgólépcsők szervizelésének,
        karbantartásának és modernizációjának szakértője. Több éves
        tapasztalatunkkal, gyors reagálási időnkkel és személyre szabott
        megoldásainkkal biztosítjuk ügyfeleink teljes körű elégedettségét.
      </p>
      <ul>
        <li>
          <strong>Megbízhatóság és pontosság:</strong> Minden karbantartást és
          szervizelést a legmagasabb szakmai színvonalon végzünk, hogy
          berendezései mindig üzemképesek legyenek.
        </li>
        <li>
          <strong>24/7 elérhetőség:</strong> Hibaelhárító szolgáltatásunk az év
          minden napján rendelkezésére áll, hogy minimálisra csökkentsük az
          állásidőt.
        </li>
        <li>
          <strong>Modernizáció élvonalbeli technológiával:</strong> Korszerű
          megoldásokkal növeljük berendezései élettartamát, hatékonyságát és
          biztonságát.
        </li>
        <li>
          <strong>Egyedi, ügyfélközpontú szolgáltatások:</strong> Igényeire
          szabott megoldásokat kínálunk, legyen szó tanácsadásról, felügyeletről
          vagy teljes körű modernizációról.
        </li>
      </ul>
      <p>
        Válassza az SOS Elevator Kft.-t, ahol a biztonság, a megbízhatóság és a
        minőség találkozik a legújabb technológiával. Forduljon hozzánk, hogy
        liftek és mozgólépcsők gondtalan működését biztosíthassuk!
      </p>
    </div>
  );
}
